import PrimeVue from '@NitrexGroup/primevue/config';
import ConfirmationService from '@NitrexGroup/primevue/confirmationservice';
import ToastService from '@NitrexGroup/primevue/toastservice';
import {
  QTooltip,
} from '@qmulus/ui';
import {
  App,
} from 'vue';

export function registerPrimevue(app: App) {
  app.use(PrimeVue);
  app.use(ToastService);
  app.use(ConfirmationService);

  app.directive('tooltip', QTooltip);
}
